import { UiDialog } from '@theme/dialog'
import { CartAddEvent } from '@theme/events'

const CartDrawerConfig = {
  selectors: {
    cta: '#shopify-installments-cta',
    paymentTerms: 'shopify-payment-terms'
  }
}

/**
 * @param {Event & { detail?: { data?: { animationDuration?: number } } }} event - Dispatched cart add event
 * @returns {number} Milliseconds left of the add to cart animation, zero when none was published
 */
export function resolveAutoOpenDelay(event) {
  const delay = event?.detail?.data?.animationDuration
  return Number.isFinite(delay) && delay > 0 ? delay : 0
}

class CartDrawerComponent extends UiDialog {
  #autoOpenTimeout

  #handleCartAdd = (event) => {
    if (!this.hasAttribute('auto-open')) {
      return
    }

    if (event?.detail?.data?.preventAutoOpen) {
      return
    }

    if (this.refs?.dialog?.open || this.dataset.nav === 'open') {
      return
    }

    const delay = resolveAutoOpenDelay(event)
    if (delay === 0) {
      this.showDialog()
      return
    }

    clearTimeout(this.#autoOpenTimeout)
    this.#autoOpenTimeout = setTimeout(() => {
      this.showDialog()
    }, delay)
  }

  connectedCallback() {
    super.connectedCallback()
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd)
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd)
    clearTimeout(this.#autoOpenTimeout)
  }

  open() {
    this.showDialog()
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector(
        CartDrawerConfig.selectors.paymentTerms
      )?.shadowRoot
      const cta = installmentsContent?.querySelector(
        CartDrawerConfig.selectors.cta
      )
      cta?.addEventListener('click', this.closeDialog, { once: true })
    })
  }
}

customElements.define('cart-drawer', CartDrawerComponent)
